const $ = window.jQuery;

const UpdateBgColor = (el, offset = -75) => {
    
    const handleScroll = () => {
        const rect = el.getBoundingClientRect();

        if (rect.bottom <= (window.innerHeight + offset) && rect.top >= (-offset)) {
            const color = $(el).data('bgSelected');
            document.body.style.setProperty("--bg-color", color);
            $('.front-page').addClass('front-page--bg-selected');
        
        } else if (rect.bottom > (window.innerHeight + offset) && rect.top > (-offset)) {
            document.body.style.removeProperty("--bg-color");
            $('.front-page').removeClass('front-page--bg-selected');
        }
    };

    window.addEventListener('scroll', handleScroll);

    // Initial call to update background colors
    handleScroll();
};

export default UpdateBgColor;



